import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { BaseHrefService } from "../../../services/base-href.service";
import { AuthService } from "../../../services/auth.service";

@Component({
  selector: "app-logout",
  templateUrl: "./logout.component.html",
  styleUrls: ["./logout.component.scss"],
})
export class LogoutComponent implements OnInit {
  @Inject(DOCUMENT) private doc: Document;

  constructor(
    public auth: AuthService,
    public baseHrefService: BaseHrefService
  ) {}

  ngOnInit(): void {}

  logout(): void {
    var loggedOut = this.baseHrefService.baseHref().endsWith("/")
      ? "logged-out"
      : "/logged-out";
    var rt =
      this.doc.location.origin + this.baseHrefService.baseHref() + loggedOut;
  }
}
